import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { campaignSettlementAPIClient } from "../campaignSettlementAPIClient";
import { CAMPAIGN_SETTLEMENT_KEYS } from "./keys";

export const CAMPAIGN_SETTLEMENT_QUERIES = {
  list: (campaignId: string) =>
    queryOptions({
      queryKey: CAMPAIGN_SETTLEMENT_KEYS.list(campaignId),
      queryFn: () =>
        campaignSettlementAPIClient.listCampaignSettlements(campaignId),
      placeholderData: keepPreviousData,
      staleTime: 30 * 1000,
      enabled: campaignId !== "",
    }),
  detail: (campaignId: string, influencerId: string) =>
    queryOptions({
      queryKey: CAMPAIGN_SETTLEMENT_KEYS.detail(campaignId, influencerId),
      queryFn: () =>
        campaignSettlementAPIClient.getCampaignInfluencerSettlement(
          campaignId,
          influencerId,
        ),
      staleTime: 30 * 1000,
      enabled: campaignId !== "" && influencerId !== "",
    }),
};
